import { render, staticRenderFns } from "./TsTextarea.vue?vue&type=template&id=136dba17&"
import script from "./TsTextarea.vue?vue&type=script&lang=js&"
export * from "./TsTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports